export default __webpack_public_path__ + "static/media/seperu-bl.bfd60429.png";